import { useTranslation } from 'react-i18next';
import mockupMobile from '@/assets/mockup-mobile.jpg';
import mockupTablet from '@/assets/mockup-tablet.jpg';

const LandingEcosystem = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 sm:py-28 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-2">{t('landing.ecosystemSubtitle')}</p>
          <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.ecosystemTitle')}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Mobile */}
          <div className="text-center space-y-4">
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/10 border border-border/50 max-w-[300px] mx-auto">
              <img src={mockupMobile} alt={t('landing.ecosystemMobile')} loading="lazy" width={640} height={800} className="w-full" />
            </div>
            <h3 className="text-lg font-semibold">{t('landing.ecosystemMobile')}</h3>
            <p className="text-sm text-muted-foreground max-w-xs mx-auto">{t('landing.ecosystemMobileDesc')}</p>
          </div>
          {/* Tablet */}
          <div className="text-center space-y-4">
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/10 border border-border/50">
              <img src={mockupTablet} alt={t('landing.ecosystemTablet')} loading="lazy" width={960} height={720} className="w-full" />
            </div>
            <h3 className="text-lg font-semibold">{t('landing.ecosystemTablet')}</h3>
            <p className="text-sm text-muted-foreground max-w-xs mx-auto">{t('landing.ecosystemTabletDesc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingEcosystem;
